module.exports = __webpack_public_path__ + "img/Screen-L@2x.64e6c895.png";